<template>
  <div>
    <empty-card
      :table="true"
      :title="$t('menu.invoices')"
    >
      <template #title>
        <b-button
          variant="dark"
          @click="handleEdit()"
        >
          {{ $t('invoice.generate') }}
        </b-button>

      </template>
      <ok-table
        ref="datatable"
        :config="config"
        @edit="handleEdit"
        @delete="handleDelete"
        @status="handleStatus"
        @table:fetch="fetchTotal"
      >
        <template
          slot="bya3com-column"
          slot-scope="{props}"
        >
          <b-badge
            variant="warning"
          >
            {{ props.row.bya3com }}
          </b-badge>

        </template>
        <template
          slot="media_type-column"
          slot-scope="{props}"
        >
          <b-badge
            :variant="getMediaTypeColor(props.row.media_type)"
          >
            {{ props.row.media_type }}
          </b-badge>

        </template>
        <template
          slot="page-column"
          slot-scope="{props}"
        >
          <div>{{ props.row.page }} <b-badge
            v-if="props.row.feature"
            variant="info"
          >
            {{ props.row.feature }}
          </b-badge></div>
        </template>
        <template
          slot="package-name-column"
          slot-scope="{props}"
        >
          <b-badge
            variant="primary"
          >
            {{ getPackageName(props.row) }}
          </b-badge>

        </template>
        <template
          slot="package-price-column"
          slot-scope="{props}"
        >
          <b-badge
            variant="success"
          >
            {{ getPackagePrice(props.row) }}
          </b-badge>

        </template>
        <template
          slot="paid-column"
          slot-scope="{props}"
        >
          <b-badge
            :variant="props.row.paid?'success':'danger'"
          >
            {{ $t(`general.${props.row.paid?'yes':'no'}`) }}
          </b-badge>

        </template>
      </ok-table>
    </empty-card>
    <div>
      <div class="text-center p-2 bg-white h2 mb-4">
        Income by Account Managers
      </div>
      <fetching-data-spinner
        :loading="totalLoading"
        :loading-title="$t('statistics.preparing-statistics')"
        enable-retry
        @retry="fetchTotal"
      />
      <manager-finance
        v-if="!totalLoading"
        :query="totalQuery"
        :managers="totalData"
      />
    </div>
    <process-invoice-modal
      v-model="showEditModal"
      :invoice="selectedInvoice"
      @updated="refreshTable"
    />
  </div>
</template>

<script>
import { BBadge, BButton } from 'bootstrap-vue'
import EmptyCard from '@/@bya3/components/cards/EmptyCard'
import OkTable from '@/@bya3/components/tables/ok-table/OkTable'
import AdminInvoicesApi from '@/api/admin/invoices'
import SubscriptionApi from '@/api/subscription'
import FormsService from '@/services/forms-service'
import FetchingDataSpinner from '@/@bya3/components/utils/FetchingDataSpinner'
import ManagerFinance from '@/views/admin/invoices/components/ManagerFinance'
import ProcessInvoiceModal from '@/views/admin/invoices/components/ProcessInvoiceModal'
import InvoicesTableConfig from './config/invoices-table-config'

export default {
  components: {
    ProcessInvoiceModal,
    ManagerFinance,
    FetchingDataSpinner,
    EmptyCard,
    OkTable,
    BBadge,
    BButton,
  },
  data() {
    return {
      config: InvoicesTableConfig,
      showEditModal: false,
      selectedInvoice: {},
      totalData: [],
      totalLoading: false,
      totalQuery: {},
    }
  },
  async mounted() {
    await this.$store.dispatch('subscription/GET_PACKAGES')
    await this.$store.dispatch('auth/FETCH_REFERRALS')
  },
  methods: {
    refreshTable() {
      this.selectedInvoice = {}
      this.$refs.datatable.loadItems()
    },
    handleEdit(props = null) {
      this.showEditModal = true
      this.selectedInvoice = props?.row ?? null
    },
    getPackageName(row) {
      return row?.package?.name ?? 'غير محدد'
    },
    getPackagePrice(row) {
      return row?.package?.price ?? 'غير محدد'
    },
    handleDelete(data) {
      this.$okConfirm(this.$t('invoice.delete-invoice-message'), {
        preConfirm: () => AdminInvoicesApi.delete(data.row.id)
          .then(response => {
            this.$notifySuccess(response.message)
            this.refreshTable()
          })
          .catch(e => this.$notifyError(e)),
      })
    },
    handleStatus(data) {
      const form = {
        paid: data.row.paid === 0 ? 1 : 0,
      }
      return SubscriptionApi.updateInvoice(data.row.id, form)
        .then(() => {
          this.$notifySuccess('تم تحديث الفاتورة بنجاح')
          const invoice = this.$refs.datatable.$data.rows.findIndex(inv => inv.id === data.row.id)
          if (invoice > -1) {
            this.$refs.datatable.$data.rows[invoice].paid = form.paid
          }
        })
        .catch(error => this.$swalError(error))
    },
    fetchTotal() {
      const filters = this.$refs.datatable?.$data?.serverParams?.columnFilters ?? {}
      const query = {}
      if (filters !== null) {
        Object.keys(filters).forEach(key => {
          if (filters[key] !== '' && filters[key] !== null) {
            query[key] = filters[key]
          }
        })
      }
      this.totalQuery = query
      const q = FormsService.prepareQueryString(query, true)

      this.totalLoading = true
      AdminInvoicesApi.total(q)
        .then(response => {
          if (response.error === 0) {
            this.totalData = response.data
          } else this.$notifyError(response.message)
        })
        .catch(error => this.$notifyError(error))
        .finally(() => { this.totalLoading = false })
    },
    getMediaTypeColor(type) {
      switch (type) {
        case 'feature': return 'success'
        case 'fb': return 'info'
        default: return 'danger'
      }
    },
  },
}
</script>
